module.exports = __webpack_public_path__ + "static/img/li2_1.5ba60a44.png";